import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _eventsView = { endDate: 'google.protobuf.Timestamp' };
var _getEventsViewRequest = {};
var _getEventsViewResponse = { eventsView: '_eventsView' };
function resolveWixCalendarEventviewsV3EventViewsServiceUrl(opts) {
    var domainToMappings = {
        'manage._base_domain_': [
            {
                srcPath: '/_api/calendar/v3/events/view',
                destPath: '/v3/events/view',
            },
        ],
        'www.wixapis.com': [
            {
                srcPath: '/calendar/v3/events/view',
                destPath: '/v3/events/view',
            },
        ],
        _: [
            {
                srcPath: '/_api/calendar/v3/events/view',
                destPath: '/v3/events/view',
            },
        ],
        '*.dev.wix-code.com': [
            {
                srcPath: '/_api/calendar/v3/events/view',
                destPath: '/v3/events/view',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/**
 * Retrieves the events view information.
 * E.g. the current view end date, or the future duration in days the view should strive for.
 */
export function getEventsView(payload) {
    var _a = serializer(_getEventsViewRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getEventsViewResponse, {
        _eventsView: _eventsView,
    }).fromJSON;
    function __getEventsView(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.calendar.v3.events_view',
            method: 'GET',
            methodFqn: 'wix.calendar.eventviews.v3.EventViewsService.GetEventsView',
            url: resolveWixCalendarEventviewsV3EventViewsServiceUrl({
                protoPath: '/v3/events/view',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getEventsView.fromReq = fromReq;
    __getEventsView.__isAmbassador = true;
    return __getEventsView;
}
//# sourceMappingURL=http.impl.js.map